import { logger } from '../../../../utils/logger';
import { getVoiceInternalsFromWindow } from './jssip-access.util';

export async function waitForSipRegistration(timeoutMs: number = 15000): Promise<void> {
  logger.debug('[CXone SDK] Waiting for SIP registration to complete...');

  const startTime = Date.now();
  const pollInterval = 100;

  return new Promise((resolve, reject) => {
    const checkRegistration = () => {
      const { audioCode, jssipUA } = getVoiceInternalsFromWindow();
      const elapsed = Date.now() - startTime;

      if (jssipUA?.isRegistered?.()) {
        logger.debug(`[CXone SDK] SIP registration completed in ${elapsed}ms`);
        resolve();
        return;
      }

      if (jssipUA && audioCode) {
        const registrator = jssipUA._registrator;
        if (
          registrator &&
          !registrator._registering &&
          !registrator._registered &&
          elapsed > 5000
        ) {
          logger.warn('[CXone SDK] SIP registration appears stuck - registrator not registering');
        }
      }

      if (elapsed >= timeoutMs) {
        logger.warn(`[CXone SDK] SIP registration timeout after ${elapsed}ms`);
        logger.warn('[CXone SDK] Final registration state:', {
          hasJssipUA: !!jssipUA,
          isConnected: jssipUA?.isConnected?.(),
          isRegistered: jssipUA?.isRegistered?.(),
        });
        reject(new Error('SIP registration timeout'));
        return;
      }

      setTimeout(checkRegistration, pollInterval);
    };

    setTimeout(checkRegistration, 200);
  });
}
